import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import FormattedStorageSpace from "../common/FormattedStorageSpace";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "../common/tables";
import { Paper, Grid, Typography } from "@mui/material";

/**
 * Styled Details Table (matching MergedUserTable styling)
 */
const Details = ({rows }) => {
  return (
    <Paper sx={{ p: 2 }}>
      <TableContainer sx={{ overflowY: "auto" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                <FormattedMessage id="admin.subscriptions.storageSpace.workspaceName" />
              </TableCell>
              <TableCell align="right">
                <FormattedMessage id="admin.subscriptions.storageSpace.desiredStorageSpace" />
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.workspaceName}>
                <TableCell>{row.siteName}</TableCell>
                <TableCell
                  align="right"
                  style={{ whiteSpace: "nowrap", verticalAlign: "top" }}
                >
                  <FormattedStorageSpace storageSpace={row.usage} unit="GB" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

Details.defaultProps = {
  className: "",
  open: false,
  rows: [],
};

Details.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      desiredStorageSpace: PropTypes.number.isRequired,
      workspaceName: PropTypes.string.isRequired,
    })
  ),
};

export default Details;
